export class OrdinaryDocumentModule {
    ordinaryDocumentID: number = 0;
    nameAr: string = '';
    nameEn: string = '';
    notes: string = '';
 }
